/** Shopify CDN: Minification failed

Line 62:4 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 63:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 81:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 84:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 95:23 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 112:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 115:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 124:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 127:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 128:12 Transforming const to the configured target environment ("es5") is not supported yet
... and 5 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 47:4 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 48:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 66:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 69:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 80:23 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 97:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 100:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 109:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 112:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 113:12 Transforming const to the configured target environment ("es5") is not supported yet
... and 5 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 32:4 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 33:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 51:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 54:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 65:23 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 82:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 85:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 94:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 97:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 98:12 Transforming const to the configured target environment ("es5") is not supported yet
... and 5 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 17:4 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 18:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 36:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 39:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 50:23 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 67:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 70:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 79:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 82:12 Transforming const to the configured target environment ("es5") is not supported yet
Line 83:12 Transforming const to the configured target environment ("es5") is not supported yet
... and 5 more hidden warnings

**/
window.shareProduct = function() {
    class ShareButton extends HTMLElement {
        constructor() {
            super();

            this.elements = {
                shareButton: this.querySelector('button'),
                successMessage: this.querySelector('[id^="ShareMessage"]'),
                urlInput: this.querySelector('input'),
                content: this.querySelector('.share-button__fallback'),
                copyButton: this.querySelector('.button-copy'),
                closeButton: this.querySelector('.share-button__close')
            }

            this.elements.shareButton.addEventListener('click', this.toggleDetails.bind(this));
            this.elements.copyButton.addEventListener('click', this.copyToClipboard.bind(this));
            this.elements.closeButton.addEventListener('click', this.closeDetails.bind(this));
            document.querySelector('.background-overlay').addEventListener('click', this.closeDetails.bind(this));
        }

        toggleDetails(event) {
            event.preventDefault();
            event.stopPropagation();
            const url = this.elements.urlInput.getAttribute('data-url');

            this.getPosition();

            this.elements.successMessage.classList.add('hidden');
            this.elements.urlInput.setAttribute('value', url);
            this.elements.urlInput.classList.remove('is-copy');
            this.elements.content.classList.toggle('is-open');
            document.querySelector('body').classList.add('modal-share-open');
        }

        copyToClipboard(event) {
            event.preventDefault();
            event.stopPropagation();

            if (!this.elements.urlInput.classList.contains('is-copy')) {
                navigator.clipboard.writeText(this.elements.urlInput.value).then(() => {
                    this.elements.successMessage.setAttribute('aria-hidden', false);
                    this.elements.urlInput.setAttribute('value', 'Link copied to clipboard!');
                    this.elements.urlInput.classList.add('is-copy');

                    setTimeout(() => {
                        this.elements.successMessage.setAttribute('aria-hidden', true);
                    }, 6000);
                });
            }
        }

        closeDetails(event) {
            event.preventDefault();
            // event.stopPropagation();
            const url = this.elements.urlInput.getAttribute('data-url');

            this.elements.successMessage.classList.add('hidden');
            this.elements.urlInput.setAttribute('value', url);
            this.elements.urlInput.classList.remove('is-copy');
            this.elements.content.classList.remove('is-open');
            document.querySelector('body').classList.remove('modal-share-open')
        }
        
        getPosition() {
            if (window.innerWidth <= 1024 || this.elements.shareButton.closest('[data-quick-view-popup]') != null) return;

            const y = this.elements.shareButton.getBoundingClientRect().top;
            const x = this.elements.shareButton.getBoundingClientRect().left;

            const width = this.elements.content.getBoundingClientRect().width;
            const shareHeight = this.elements.shareButton.getBoundingClientRect().height;
            const shareWidth = this.elements.shareButton.getBoundingClientRect().width;

            const left = x - width + shareWidth;
            const top = y + shareHeight + 10;

            this.elements.content.style.setProperty('--share-desk-top', top + 'px');
            this.elements.content.style.setProperty('--share-desk-left', left + 'px');
        }
    }

    customElements.define('share-button', ShareButton);
};

var shareShow = document.body.classList.contains('quick-view-show'),
    productShare = $('.halo-productView .productView-share').length;

if (document.body.classList.contains('template-product')) {
    if (!shareShow && productShare) {
        window.shareProduct();
    } else if (shareShow && productShare === 0) {
        window.shareProduct();
    }
} else {
    window.shareProduct();
}